export default __webpack_public_path__ + "static/builder-default-image-f6c1deb53732fae5990e3ff0de1d71c7.jpg";